<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-row class="fill-height" no-gutters>
          <v-col class="col-12">
            <v-row>
              <v-col class="col-12">
                <v-card-title>
                  <v-row>
                    <v-col class="col-12 col-md-4">
                      <h1 class="primary-color">Visible Behaviours</h1>
                    </v-col>
                    <v-spacer />
                    <v-col class="col-12 col-md-2">
                      <v-btn class="new-item-btn float-right" block @click="openCreateVisibleBehaviour">
                        <v-icon size="20">mdi-plus</v-icon>
                        &nbsp;&nbsp;Create visible behaviour
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-alert
                  v-if="messageCreate"
                  outlined
                  :color="successfullCreate ? 'success' : 'error'"
                  :icon="successfullCreate ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageCreate }}
                </v-alert>
                <v-alert
                  v-if="messageDelete"
                  outlined
                  :color="successfullDelete ? 'success' : 'error'"
                  :icon="successfullDelete ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageDelete }}
                </v-alert>
                <v-alert
                  v-if="messageEdit"
                  outlined
                  :color="successfullEdit ? 'success' : 'error'"
                  :icon="successfullEdit ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageEdit }}
                </v-alert>

                <v-data-table
                  :headers="headers"
                  :items="visibleBehaviours"
                  item-key="id"
                  :loading="loading"
                  loading-text="Loading... Please, wait"
                  :server-items-length="pagination.totalItems"
                  :items-per-page="pagination.itemsPerPage"
                  :page.sync="pagination.page"
                  item-class="text-wrap"
                  @update:page="handlePageChange"
                >
                  <template #[`item.createdAt`]="{ item }">
                    {{ item.createdAt | formatDate }}
                  </template>
                  <template #[`item.actions`]="{ item }">
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openShowDetails(item)">
                          <v-icon size="20" color="primary">mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Show details</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openEditVisibleBehaviour(item)">
                          <v-icon size="20" color="primary">mdi-square-edit-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit visible behaviour</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openDeleteVisibleBehaviour(item)">
                          <v-icon size="20" color="error">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete visible behaviour</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-alert
              v-if="messageList"
              class="mt-4"
              outlined
              :color="successfullList ? 'success' : 'error'"
              :icon="successfullList ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageList }}
            </v-alert>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <v-dialog v-model="createDialog" max-width="600" persistent>
      <v-card>
        <v-form ref="createForm" @submit.prevent="createVisibleBehaviour">
          <v-card-title class="px-6">
            <h5 class="primary-color">Create Visible Behaviour</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="visibleBehaviour.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-textarea
                    v-model="visibleBehaviour.description"
                    class="py-0 mb-6 no-border-radius"
                    label="Description"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-text-field
                    v-model="visibleBehaviour.idBeon"
                    class="py-0 mb-6 no-border-radius"
                    label="Id Beon *"
                    type="number"
                    min="1"
                    :rules="rulesNumber"
                    dense
                  />
                </v-col>
              </v-row>
              <v-alert
                v-if="messageCreateInside"
                class="mb-0 mt-3"
                outlined
                :color="successfullCreateInside ? 'success' : 'error'"
                :icon="successfullCreateInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageCreateInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="cancelCreate"> Cancel </v-btn>
            <v-btn v-if="!creating" type="submit" class="ok-modal"> Create </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" max-width="600" persistent>
      <v-card>
        <v-form ref="editForm" @submit.prevent="editVisibleBehaviour">
          <v-card-title class="px-6">
            <h5 class="primary-color">Update Visible Behaviour</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="itemToEdit.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-textarea
                    v-model="itemToEdit.description"
                    class="py-0 mb-6 no-border-radius"
                    label="Description"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-text-field
                    v-model="itemToEdit.idBeon"
                    class="py-0 mb-6 no-border-radius"
                    label="Id Beon *"
                    type="number"
                    min="1"
                    :rules="rulesNumber"
                    dense
                  />
                </v-col>
              </v-row>
              <v-alert
                v-if="messageEditInside"
                class="mb-0 mt-3"
                outlined
                :color="successfullEditInside ? 'success' : 'error'"
                :icon="successfullEditInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageEditInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="editDialog = false"> Cancel </v-btn>
            <v-btn v-if="!editing" type="submit" class="ok-modal"> Update </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card>
        <v-card-title class="px-6">
          <h5 class="primary-color">Delete Visible Behaviour</h5>
        </v-card-title>
        <v-card-text class="mt-4 pb-0 px-6">
          <p class="mb-0">
            Do you really want to delete the selected visible behaviour? <br />
            If so, press Confirm.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn text class="cancel-modal" @click="deleteDialog = false"> Cancel </v-btn>

          <template v-if="!deleting">
            <v-btn class="ok-modal" @click="deleteVisibleBehaviour"> Confirm </v-btn>
          </template>
          <v-btn v-else class="ok-modal" disabled @click="deleteVisibleBehaviour">
            <v-progress-circular indeterminate color="primary" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDetailsDialog" max-width="800">
      <v-card>
        <v-card-title class="px-6">
          <h5 class="primary-color">Details</h5>
        </v-card-title>
        <v-card-text class="mt-4 pb-0 px-6">
          <v-container>
            <v-row>
              <v-col cols="4">
                <h6 class="details-subtitles primary-color">Name:</h6>
              </v-col>
              <v-col cols="8">
                <p class="mb-0">{{ itemToShow.name }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <h6 class="details-subtitles primary-color">Description:</h6>
              </v-col>
              <v-col cols="8">
                <p class="mb-0">{{ itemToShow.description }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <h6 class="details-subtitles primary-color">Id Beon:</h6>
              </v-col>
              <v-col cols="8">
                <p class="mb-0">{{ itemToShow.idBeon }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer />
          <v-btn text class="cancel-modal" @click="showDetailsDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import VisibleBehavioursDataService from '@/services/VisibleBehavioursDataService';

export default {
  name: 'VisibleBehavioursList',
  data() {
    return {
      visibleBehaviours: [],
      successfullList: false,
      messageList: '',
      loading: false,
      successfullCreate: false,
      messageCreate: '',
      successfullCreateInside: false,
      messageCreateInside: '',
      successfullEdit: false,
      messageEdit: '',
      successfullEditInside: false,
      messageEditInside: '',
      successfullDelete: false,
      messageDelete: '',
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Id Beon', value: 'idBeon', sortable: false },
        { text: 'Created at', value: 'createdAt', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalPages: 1,
        totalItems: 0,
      },
      visibleBehaviour: {
        name: '',
        description: '',
        idBeon: null,
      },
      rules: [(v) => !!v || 'Required field'],
      rulesNumber: [(v) => v !== '' && v != null && v > 0 || 'Required positive number'],
      createDialog: false,
      creating: false,
      editDialog: false,
      editing: false,
      deleteDialog: false,
      deleting: false,
      itemToEdit: {},
      itemToDelete: {},
      itemToShow: {},
      showDetailsDialog: false,
    };
  },
  async mounted() {
    await this.getAll(1);
  },
  methods: {
    getAll(page) {
      this.loading = true;

      VisibleBehavioursDataService.findAll(
        page,
        this.pagination.itemsPerPage
      ).then(
        (response) => {
          if (response.status == 200) {
            this.visibleBehaviours = response.data.data || [];

            if (this.visibleBehaviours.length !== 0 || page === 1) {
              this.pagination.page = page;
              this.pagination.totalPages = response.data.links?.totalPages || 1;
              this.pagination.totalItems =
                response.data.links?.totalItems ||
                this.pagination.totalPages * this.pagination.itemsPerPage;
            }
          } else {
            this.successfullList = false;
            this.messageList =
              'An error has occurred retrieving the list of visible behaviours. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullList = false;
          this.messageList =
            'An error has occurred retrieving the list of visible behaviours. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.getAll(newPage);
    },
    openCreateVisibleBehaviour() {
      this.createDialog = true;
    },
    createVisibleBehaviour() {
      this.successfullCreate = true;
      this.messageCreate = '';

      if (this.$refs.createForm.validate()) {
        this.creating = true;

        VisibleBehavioursDataService.create(this.visibleBehaviour).then(
          (response) => {
            if (response.status == 201) {
              this.getAll(1);
              this.messageCreate = 'Visible behaviour successfully created.';
              this.successfullCreate = true;
            } else {
              this.messageCreate =
                'An error has occurred creating the visible behaviour. Please, try again later.';
              this.successfullCreate = false;
            }

            this.createDialog = false;
            this.creating = false;
            this.visibleBehaviour = { name: '', description: '', idBeon: null };
          },
          (error) => {
            this.messageCreateInside = '';

            if (error.response && error.response.status === 409) {
              this.successfullCreateInside = false;
              this.messageCreateInside = 'Id Beon already in use. Please, use a different value.';
            } else if (
              error.response &&
              (error.response.status === 401 || error.response.status === 403)
            ) {
              localStorage.removeItem('user');
              this.$router.push('/');
            } else {
              this.successfullCreate = false;
              this.messageCreate =
                'An error has occurred creating the visible behaviour. Please, try again later.';
            }

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            this.creating = false;
          }
        );
      }
    },
    cancelCreate() {
      this.createDialog = false;
      this.visibleBehaviour = { name: '', description: '', idBeon: null };
    },
    openEditVisibleBehaviour(item) {
      this.itemToEdit = { ...item };
      this.editDialog = true;
    },
    editVisibleBehaviour() {
      this.successfullEdit = true;

      if (this.$refs.editForm.validate()) {
        this.editing = true;

        VisibleBehavioursDataService.update(this.itemToEdit).then(
          (response) => {
            if (response.status == 204) {
              this.getAll(1);
              this.messageEdit = 'Visible behaviour successfully updated.';
              this.successfullEdit = true;
            } else {
              this.messageEdit =
                'An error has occurred updating the visible behaviour. Please, try again later.';
              this.successfullEdit = false;
            }

            this.editDialog = false;
            this.editing = false;
            this.itemToEdit = {};
          },
          (error) => {
            this.messageEditInside = '';

            if (error.response && error.response.status === 409) {
              this.successfullEditInside = false;
              this.messageEditInside = 'Id Beon already in use. Please, use a different value.';
            } else if (
              error.response &&
              (error.response.status === 401 || error.response.status === 403)
            ) {
              localStorage.removeItem('user');
              this.$router.push('/');
            } else {
              this.successfullEdit = false;
              this.messageEdit =
                'An error has occurred updating the visible behaviour. Please, try again later.';
            }

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            this.editing = false;
          }
        );
      }
    },
    openDeleteVisibleBehaviour(item) {
      this.itemToDelete = { ...item };
      this.deleteDialog = true;
    },
    deleteVisibleBehaviour() {
      if (this.itemToDelete.id !== undefined) {
        this.deleting = true;

        VisibleBehavioursDataService.delete(this.itemToDelete.id).then(
          (response) => {
            if (response.status == 204) {
              this.getAll(1);
              this.messageDelete = 'Visible behaviour successfully deleted.';
              this.successfullDelete = true;
            } else {
              this.messageDelete =
                'An error has occurred deleting the visible behaviour. Please, try again later.';
              this.successfullDelete = false;
            }

            this.deleteDialog = false;
            this.deleting = false;
            this.itemToDelete = {};
          },
          (error) => {
            this.messageDelete =
              'An error has occurred deleting the visible behaviour. Please, try again later.';
            this.successfullDelete = false;

            this.deleteDialog = false;
            this.deleting = false;
            this.itemToDelete = {};

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
              localStorage.removeItem('user');
              this.$router.push('/');
            }
          }
        );
      } else {
        this.deleteDialog = false;
        this.itemToDelete = {};
      }
    },
    openShowDetails(item) {
      this.itemToShow = { ...item };
      this.showDetailsDialog = true;
    },
  },
};
</script>
